<template>
    <div>
        <b-modal
            id="deleteActivityModal"
            ref="deleteActivityModal"
            :lazy="true"
            title-tag="h2"
            :title="title"
        >
            <b-alert show variant="warning" v-if="locked">
                {{ locked.message }}
            </b-alert>
            <p v-if="data.occurenceID">
                {{ activity.status === 1 ? "Delete" : "Deactivate" }} an
                activity will remove it from this patient's treatment. Please
                select whether to
                {{ activity.status === 1 ? "delete" : "deactivate" }} this
                activity only or all recurrences of this activity.
            </p>
            <p v-else>
                {{ activity.status === 1 ? "Delete" : "Deactivate" }} an
                activity will remove it from this patient's treatment.
            </p>

            <b-form-group
                v-if="data.occurenceID"
                :label-for="`apply_to`"
                :label-cols="2"
                label="Apply To:"
            >
                <b-form-select
                    :disabled="is_locked"
                    v-model="data.isApplyAllEvents"
                    v-validate="'required'"
                    :options="applyToOptions"
                    name="apply_to"
                ></b-form-select>
            </b-form-group>

            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.deleteActivityModal.hide('cancel')"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button
                        :disabled="is_locked"
                        v-if="!loading && activity.status === 1"
                        @click="deleteActivity(1)"
                        class="float-left"
                        variant="primary"
                        >Delete</b-button
                    >
                    <b-button
                        :disabled="is_locked"
                        v-if="!loading && activity.status === 0"
                        @click="deleteActivity(0)"
                        class="float-left"
                        variant="primary"
                        >Deactivate</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { some } from "lodash";
import ScheduleHelper from "../helper";
export default {
    data() {
        return {
            loading: false,
            continues: false,
            title: "Delete Activity",
            data: {
                activityID: "",
                occurenceID: "",
                isApplyAllEvents: 0
            },
            activity: [],
            patient: [],
            applyToOptions: [
                {
                    value: 0,
                    text: "This activity only"
                },
                {
                    value: 1,
                    text: "This and all future occurrences of this activity"
                }
            ]
        };
    },
    mixins: [ScheduleHelper],
    computed: {
        locked() {
            return (
                this.activity?.locked ||
                this.$store.getters.locked(this.activity?.id)
            );
        },
        is_locked() {
            return some(this.locked);
        }
    },
    watch: {},
    methods: {
        open(activity, patient) {
            this.activity = activity;
            this.patient = patient;
            this.data.activityID = activity.id;
            this.data.occurenceID = activity.occurrence_id;

            switch (this.activity.status) {
                case this.TREATMENT_ACTIVITY_STATUS.PENDING:
                    this.title = "Deactivate Activity";

                    break;
                case this.TREATMENT_ACTIVITY_STATUS.DEACTIVATED:
                    this.title = "Activate Activity";

                    break;

                default:
                    break;
            }
            this.$refs.deleteActivityModal.show();
        },
        async deleteActivity(status) {
            let self = this;
            let response = [];
            this.loading = true;

            if (status) {
                if (self.activity.status === 1) {
                    switch (self.activity.treatment_activity_type_id) {
                        case 1:
                            await self.preDeletedRecord(
                                self.data.isApplyAllEvents
                            );
                            break;
                        case 2:
                            self.preDeletedVital(self.data.isApplyAllEvents);
                            break;

                        default:
                            break;
                    }
                }

                if (!self.data.isApplyAllEvents) {
                    response = await this.$http.delete(
                        process.env.BARRACUDA +
                            "/schedule/activity/" +
                            self.data.activityID
                    );
                } else {
                    response = await this.$http.delete(
                        process.env.BARRACUDA +
                            "/schedule/group-activities/" +
                            self.data.occurenceID
                    );
                }
            } else {
                let data = {
                    treatment_board_id: self.activity.treatment_board_id,
                    treatment_activity_type_id:
                        self.activity.treatment_activity_type_id,
                    due: self.activity.due,
                    status: 3,
                    otherTasks: [],
                    medications: [],
                    vitals: []
                };

                if (!self.data.isApplyAllEvents) {
                    response = await this.$http.put(
                        process.env.BARRACUDA +
                            "schedule/activity/" +
                            self.activity.id,
                        data
                    );
                } else {
                    response = await self
                        .getGroupActivity(self.data.occurenceID)
                        .then(response => {
                            self.futureActivity = _.filter(
                                response.data.response.resources,
                                { status: 0 }
                            ).map(data => ({
                                ...data,
                                status: 3
                            }));
                            return self.updateGroupActivity(
                                self.futureActivity
                            );
                        });
                }
            }

            if (response && response.data.response.message.code === 200) {
                self.$refs.deleteActivityModal.hide();
                self._message(
                    self.activity.status === 1
                        ? "Activity deleted"
                        : "Activity deactivated",
                    "success"
                );
                self.$root.$emit("treatment-board-refresh", {
                    params: response.data.response,
                    treatment_board_id: self.activity.treatment_board_id
                });
                self.$socket.client.emit("v-broadcast-all", {
                    params: response.data.response,
                    action: "refresh-vital",
                    patient_id: self.patient.id,
                    businessId: self._setting.business_id
                });
            } else {
                this.loading = false;
                self._message(
                    self.activity.status === 1
                        ? "Activity delete error"
                        : "Activity deactivate error",
                    "danger"
                );
            }
            return response;
        },
        async preDeletedRecord(isApplyAllEvents) {
            let self = this;
            if (!isApplyAllEvents) {
                let response = await self.getActivity(self.data.activityID);
                await self.deleteRecord(
                    response.data.response.resources.medications[0].record_id
                );
            } else {
                await self
                    .getGroupActivity(self.data.occurenceID)
                    .then(function (response) {
                        response.data.response.resources.forEach(element => {
                            if (element.medications[0].record_id) {
                                self.deleteRecord(
                                    element.medications[0].record_id
                                );
                            }
                        });
                    });
            }
        },
        async preDeletedVital(isApplyAllEvents) {
            let self = this;
            if (!isApplyAllEvents) {
                await self
                    .getActivity(self.data.activityID)
                    .then(function (response) {
                        self.deleteVital(
                            response.data.response.resources.treatment_vitals[0]
                                .vital_id
                        );
                    });
            } else {
                await self
                    .getGroupActivity(self.data.occurenceID)
                    .then(function (response) {
                        response.data.response.resources.forEach(element => {
                            if (element.treatment_vitals[0].vital_id) {
                                self.deleteVital(
                                    element.treatment_vitals[0].vital_id
                                );
                            }
                        });
                    });
            }
        },
        async deleteRecord(recordID) {
            let res = await $.post(
                process.env.APPS + "index.php/patient/record/remove",
                { id: recordID }
            );
            return res;
        },
        deleteVital(vitalID) {
            return $.post(process.env.APPS + "index.php/patient/vital/remove", {
                id: vitalID
            });
        },
        getActivity(activityID) {
            return this.$http.get(
                process.env.BARRACUDA + "/schedule/activity/" + activityID
            );
        },
        getGroupActivity(occurenceID) {
            return this.$http.get(
                process.env.BARRACUDA +
                    "/schedule/group-activities/" +
                    occurenceID
            );
        },
        async updateGroupActivity(data) {
            return await this.$http.put(
                process.env.BARRAMUNDI + "/schedule/group-activities",
                data
            );
        }
    }
};
</script>
